import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux/toolkit';
import { Container } from 'inversify';
import { setApiError, setFeatureDataList } from '@edikk-edikk/redux/slice-base';
import { ApiError } from '@edikk-edikk/network-service';
import { InitResponseType } from '#base/api/types/InitResponseType';
import { API_BASE_NAME, BASE_LOAD_URL } from '#base/constants';

const getApiBase = (diContainer: Container) => createApi({
  reducerPath: API_BASE_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    init: builder.query<InitResponseType, string>({
      query: (slug: string) => ({
        url: BASE_LOAD_URL,
        params: {
          slug,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then((response) => {
          if (response.data.isNotFound) {
            dispatch(setApiError(new ApiError(404).toObject()));
          }

          dispatch(setFeatureDataList(response.data.featureList));
        }).catch(() => null);
      },
    }),
  }),
});

export { getApiBase };
